import { ENV } from '../../environment';

type Config = {
  beaconKey: string;
};

const DevEnv: Config = {
  beaconKey: '29d9a6068d',
};

const StagingEnv: Config = {
  beaconKey: '29d9a6068d',
};

const ProdEnv: Config = {
  beaconKey: '74d9f3a1bd',
};

export const config: Config = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
